import { useState, useRef, useEffect } from 'react';

function LazyVideo({ src, classNames }) {
  const containerRef = useRef<HTMLDivElement>(null);
  const videoRef = useRef<HTMLVideoElement>(null);
  const [isVisible, setIsVisible] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setIsVisible(true); },
      { rootMargin: '300px' }
    );
    if (containerRef.current) observer.observe(containerRef.current);
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    if (isVisible && videoRef.current) {
      videoRef.current.play().catch(() => {});
    }
  }, [isVisible]);

  return (
    <div ref={containerRef} className="video-container" aria-hidden="true" >
      {isVisible && (
        <video
          ref={videoRef}
          autoPlay
          muted
          loop
          playsInline
          preload="none"
          onLoadedData={() => setIsLoaded(true)}
          className={classNames}
          style={{
            transition: 'opacity 0.3s ease',
            opacity: isLoaded ? 1 : 0,
          }}
        >
          <source src={src} type="video/mp4" />
        </video>
      )}
    </div>
  );
}

export default LazyVideo;
